export default [
    // *===================Assets============================---*
    {
        path: '/assets',
            name: 'assets',
            component: () => import('@/views/accounting/assets/Assets.vue'),
            meta: {
                pageTitle: 'Assets',
                breadcrumb: [
                    {
                        text: 'Assets',
                        active: true,
                    },
                ],
                //permission: 'Permissions.Accounting.View'            
            },
    }
    ]